import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { conversionOptions } from "../../pages/CaseScenarios/dropDownOptions.js";
import { toast } from "react-toastify";

const initialState = {
  loading: false,
  conversionData: {
    description: "",
    source_code: "",
    target_code: "",
    tdd: "",
    judge_response: ""
  },
};

// Dynamically create async thunks for each conversion type
const asyncThunks = conversionOptions.reduce((acc, option) => {
  acc[option.action] = createAsyncThunk(
    `caseScenarios/${option.action}`,
    option.api
  );
  return acc;
}, {});

export const caseScenariosSlice = createSlice({
  name: "caseScenarios",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    conversionOptions.forEach((option) => {
      builder
        .addCase(asyncThunks[option.action].pending, (state) => {
          state.loading = true;
        })
        .addCase(asyncThunks[option.action].fulfilled, (state, action) => {
          state.loading = false;
          state.conversionData = action.payload;
        })
        .addCase(asyncThunks[option.action].rejected, (state, action) => {
          state.loading = false;
          toast.error(action.error.message);
        });
    });
  },
});

export const caseScenarioActions = asyncThunks;
export default caseScenariosSlice.reducer;